export enum UserAccessEnum {
	CONFIRMER = 'CONFIRMER',
	EDIT_INDEX = 'EDIT_INDEX',
	OFFICE_MANAGE_RELEASE_NUDGE = 'OFFICE_MANAGE_RELEASE_NUDGE',
}
